import { render } from "./Redirect.vue?vue&type=template&id=085b14d3&scoped=true&ts=true"
import script from "./Redirect.vue?vue&type=script&lang=ts"
export * from "./Redirect.vue?vue&type=script&lang=ts"

import "./Redirect.vue?vue&type=style&index=0&id=085b14d3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085b14d3"]])

export default __exports__